import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import SEO from "../../components/SEO";
import events, { findEventBySlug } from "../../data/events";
import asset from "../../utils/assetUrl";
import { googleCalendarUrl, icsUrl, outlookCalendarUrl } from "../../utils/calendar";

// /calendario/<sede>: a donde lleva el boton "Agregar a mi calendario" del
// WhatsApp de una semana antes. El slug va dentro del template aprobado por
// Meta, asi que esta ruta no puede cambiar de nombre.

const SITE = 'https://conferenciaparacanada.com';
const TZ = 'America/Mexico_City';

const formatDay = (iso) => {
    const text = new Date(iso).toLocaleDateString('es-MX', {
        weekday: 'long', day: 'numeric', month: 'long', timeZone: TZ
    });
    return text.charAt(0).toUpperCase() + text.slice(1);
};

const formatTime = (iso) =>
    new Date(iso).toLocaleTimeString('es-MX', { hour: 'numeric', minute: '2-digit', timeZone: TZ });

// El boton principal es el calendario que ya trae el telefono: en iPhone el
// .ics abre directo "Agregar al calendario"; en Android casi todos usan Google.
const isApple = () => {
    const ua = navigator.userAgent || '';
    return /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
};

function Calendario() {
    const { sede } = useParams();
    const evento = findEventBySlug(sede);

    // Mismas tarjetas y botones que /gracias, que ya viven bajo body.thanks.
    useEffect(() => {
        document.body.classList.add('thanks');
        return () => {
            document.body.classList.remove('thanks');
        };
    }, []);

    const buttons = evento
        ? [
            { key: 'apple', label: 'Apple / iPhone', href: icsUrl(evento) },
            { key: 'google', label: 'Google Calendar', href: googleCalendarUrl(evento), external: true },
            { key: 'outlook', label: 'Outlook', href: outlookCalendarUrl(evento), external: true }
        ]
        : [];
    if (buttons.length && !isApple()) {
        buttons.unshift(buttons.splice(1, 1)[0]);
    }

    return (
        <>
            <SEO
                title={evento ? `Agrega la Conferencia para Canadá en ${evento.city} a tu calendario` : 'Agrega la Conferencia para Canadá a tu calendario'}
                description="Guarda la fecha en tu calendario y recibe también sus recordatorios."
                keywords="conferencia para canada, calendario"
                ogImage={`${SITE}/assets/images/og.jpg`}
                favicon={`${SITE}/assets/images/favicon-32x32.png`}
                appleFavicon={`${SITE}/assets/images/apple-touch-icon.png`}
                canonical={`${SITE}/calendario${evento ? `/${evento.slug}` : ''}`}
                noindex
            />

            <div style={{ backgroundImage: `url(${asset('/assets/images/hero.jpg')})` }} className="hero hero--full nostatic">
                <div className="container">
                    <img className="mainLogo" src={asset("/assets/images/Para_Canada_Conferencia_Logo_White.svg")} alt="Conferencia para Canadá" />
                    <hr />
                    <h1>Agrégala a tu calendario</h1>

                    {evento ? (
                        <>
                            <div className="thanks__event">
                                <p className="thanks__event-city">{evento.city}</p>
                                <p className="thanks__event-venue">
                                    {formatDay(evento.start)} · {formatTime(evento.start)} a {formatTime(evento.end)}
                                </p>
                                <p className="thanks__event-venue">{evento.venue}</p>
                                <p className="thanks__event-street">{evento.street}</p>
                            </div>

                            <p className="thanks__hint">
                                Elige el calendario que usas y tu propio teléfono también te recordará la
                                Conferencia.
                            </p>

                            <div className="thanks__actions">
                                {buttons.map((b, i) => (
                                    <a
                                        key={b.key}
                                        className={i === 0 ? 'button' : 'button button--light'}
                                        href={b.href}
                                        {...(b.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                                    >
                                        {b.label}
                                    </a>
                                ))}
                            </div>

                            <p className="thanks__hint thanks__hint--small">
                                ¿Usas otro calendario? El botón de Apple descarga un archivo .ics que también
                                sirve para Outlook de escritorio y la mayoría de calendarios.
                            </p>
                        </>
                    ) : (
                        <>
                            <p className="thanks__hint">¿En qué ciudad asistirás?</p>
                            <div className="thanks__actions">
                                {events.map((e) => (
                                    <Link key={e.slug} className="button" to={`/calendario/${e.slug}`}>
                                        {e.city}
                                    </Link>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default Calendario;
